import { IGif } from '@giphy/js-types'
import { ClipIcon } from 'ui/src/icons/content-types'

interface IGifWithVideo extends IGif {
    is_video?: boolean
}

const ClipOverlay = ({ gif }: { gif: IGif }) => {
    const gifWithVideo = gif as IGifWithVideo

    return gifWithVideo.is_video ? (
        <div className="pointer-events-none absolute inset-0 flex select-none items-center justify-center">
            <ClipIcon className="fill-giphyWhite size-7 ml-2 absolute top-2 left-0" />
        </div>
    ) : null
}

export default ClipOverlay
